module.exports = __webpack_public_path__ + "img/totem.c3e705d5.png";